const GA_MEASUREMENT_ID = "G-6N6PS2X5MW";
const CONSENT_KEY = "ga_consent";

let initialized = false;

const isLocalhost = () => {
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
};

export const isAnalyticsAllowed = () => {
  return localStorage.getItem(CONSENT_KEY) === "granted";
};

export const setAnalyticsConsent = (allowed) => {
  localStorage.setItem(CONSENT_KEY, allowed ? "granted" : "denied");
};

export const initGA = () => {
  if (initialized || !GA_MEASUREMENT_ID) return;
  if (isLocalhost()) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });

  initialized = true;
};

export const trackPageView = (path) => {
  if (!initialized || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};
